$(function() {
    // Initialize the ScrollIt plugin with a scroll time of 150 milliseconds
    $.scrollIt ({
        scrollTime: 150
    });
});
